export { FooterPartners } from './FooterPartners';
